import React from 'react'


export default class extends React.Component {

  render() {
    if(!this.props.logged_in) {
      return (
        <div className="full big orange">
          <div className="wrap content-text">
            <h2 className="cta-title">Get Beta access</h2>
            <p style={{textAlign:"center"}}>Use all features for free with the Beta, you only need an email address to get started.</p>
            <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-e btn-fat">Start NOW</button></div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="orange" style={{height:"7px"}}></div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartFooterCTA.js